import React from 'react';

export default class WorkPerformanceOne extends React.Component {
    componentDidMount() {
        const $ = window.$;
        
        if ($('.dial').length) {
            $('.dial').appear(function () {
              var elm = $(this);
              var perc = elm.attr('value');
              elm.knob({
                'value': 0,
                'min': 0,
                'max': 100,
                'skin': 'tron',
                'readOnly': true,
                'thickness': 0.15,
                'dynamicDraw': true,
                'displayInput': false
              });
              $({ value: 0 }).animate({ value: perc }, {
                duration: 2000,
                easing: 'swing',
                progress: function () {
                  elm.val(Math.ceil(this.value)).trigger('change');
                }
              });
            }, { accY: 20 });
        }

        if ($(".count-box").length) {
            $(".count-box").appear(function () {
                var $t = $(this),
                    n = $t.find(".count-text").attr("data-stop"),
                    r = parseInt($t.find(".count-text").attr("data-speed"), 10);

                if (!$t.hasClass("counted")) {
                    $t.addClass("counted");
                    $({ countNum: $t.find(".count-text").text() }).animate({
                        countNum: n,
                    }, {
                        duration: r,
                        easing: "linear",
                        step: function () {
                            $t.find(".count-text").text(Math.floor(this.countNum));
                        },
                        complete: function () {
                            $t.find(".count-text").text(this.countNum);
                        },
                    });
                }
            }, { accY: 0 });
        }
    }

    render() {
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="work-perfomance-one-sec">
                    <div className="container">
                        <div className="row">
                            {/* Content */}
                            <div className="col-xl-7">
                                <div className="work-perfomance-one__content">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6>Work Performance</h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title">
                                            Delivering Reliable <br /> Marine Equipment Worldwide
                                        </h2>
                                        <p className="sec-title__text">
                                            From compressors and pumps to purifiers and navigation systems, 
                                            we supply only genuine and trusted ship equipment. 
                                            Our commitment to quality ensures vessels operate efficiently, 
                                            safely, and without downtime. With years of experience, 
                                            we have earned the trust of ship owners and operators globally.
                                        </p>
                                    </div>

                                    <div className="work-perfomance-one__content-bottom">
                                        <div className="progress-box">
                                            <div className="inner-box">
                                                <div className="graph-outer">
                                                    <input type="text" 
                                                        className="dial" 
                                                        data-fgColor="#ff5e14"
                                                        data-bgColor="#ebebeb" 
                                                        data-width="100" 
                                                        data-height="100"
                                                        data-linecap="normal" 
                                                        value="100" />
                                                    <div className="inner-text count-box">
                                                        <span className="count-text" data-stop="100" data-speed="2000"></span>
                                                        <span className="count-Parsent">%</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-box">
                                            <h2>100% Satisfied Customers</h2>
                                            <p>
                                                Our customers rely on us because we deliver on time, 
                                                provide genuine spares, and maintain the highest service standards. 
                                                Your satisfaction is our success.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Image */}
                            <div className="col-xl-5">
                                <div className="work-perfomance-one__img">
                                    <img src={publicUrl+"assets/images/services/safety2.png"} alt="Marine Work Performance" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
